const FuelTypes = [
  { label: 'Diesel', value: 'diesel' },
  { label: 'Electric', value: 'electric' },
  { label: 'Hybrid', value: 'hybrid' },
  { label: 'Lpg', value: 'lpg' },
  { label: 'Petrol', value: 'petrol' },
]

export default FuelTypes
